import React from "react";
import PropTypes from "prop-types";
import FacilityKpiIndicatorsContainer from "../kpiIndicators/components/FacilityKpiIndicatorsContainer";

const FacilityKpiIndicatorsStepContainer = ({ documentId, siteId, isFromFacility, hasFacilityOffer }) => {
  return <FacilityKpiIndicatorsContainer documentId={documentId} siteId={siteId} isFromFacility={isFromFacility} hasFacilityOffer={hasFacilityOffer}/>;
};

FacilityKpiIndicatorsStepContainer.propTypes = {
  documentId: PropTypes.number,
  siteId: PropTypes.number,
  isFromFacility: PropTypes.bool,
  hasFacilityOffer: PropTypes.bool
};

export default FacilityKpiIndicatorsStepContainer;
